import { render, staticRenderFns } from "./hotelOrder.vue?vue&type=template&id=9d21aab2&"
import script from "./hotelOrder.vue?vue&type=script&lang=ts&"
export * from "./hotelOrder.vue?vue&type=script&lang=ts&"
import style0 from "./hotelOrder.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports